// extracted by mini-css-extract-plugin
export default {"vlButton":"style_vlButton__fu5jN"};